// components/textareaTheme.js
const TextareaTheme = {
  variants: {
    outline: {
      fontFamily: "'Inter', sans-serif",
      fontSize: "14px",
      lineHeight: "26px",
      color: "#222222",
      bg: "#F3F3F5",
      border: "1px solid #E6E8EE",
      borderRadius: "10px",
      px: "14px",
      py: "12px",
      transition: "all 0.2s ease",
      minHeight: "120px",
      resize: "vertical",

      _placeholder: { color: "#999999" },
      _hover: { borderColor: "#666666" },
      _focus: {
        borderColor: "#666666",
        boxShadow: "0 0 0 1px #666666",
      },
    },
  },

  defaultProps: {
    size: "sm",
    variant: "outline",
  },
};

export default TextareaTheme;
